import React from "react";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";

interface DesktopNavLinkProps {
  href: string;
  children: React.ReactNode;
  accentColor?: string;
  accentColorPastel?: string;
  isSpecial?: boolean;
}

export const DesktopMenu: React.FC = () => {
  const location = useLocation();

  // Paleta de colores para accent/active y sus versiones pastel para hover
  const colorPairs = [
    { accent: "#FF6B8A", pastel: "#FFE5ED" }, // Rosa Coral
    { accent: "#4D96FF", pastel: "#E3F2FF" }, // Azul Cielo
    { accent: "#FFD93D", pastel: "#FFF8E1" }, // Amarillo Sol
    { accent: "#6BCB77", pastel: "#E8F5E9" }, // Verde Menta
    { accent: "#A855F7", pastel: "#F3E5F5" }, // Lila
    { accent: "#FF8A56", pastel: "#FFE9E1" }, // Naranja
  ];

  const DesktopNavLink: React.FC<DesktopNavLinkProps> = ({
    href,
    children,
    accentColor,
    accentColorPastel,
    isSpecial = false
  }) => {
    const isActive = location.pathname === href || location.pathname.startsWith(`${href}/`);

    return (
      <Link
        to={href}
        className={classNames(
          "relative inline-block rounded-lg px-3 py-1.5 text-sm font-medium transition-colors duration-300 overflow-hidden group",
          isSpecial && !isActive && "text-[#4D96FF]",
          !isSpecial && !isActive && "text-slate-700"
        )}
        style={isActive ? {
          color: accentColor,
          backgroundColor: `${accentColor}30`,
          fontWeight: 600
        } : {}}
      >
        {/* Efecto pincelada de izquierda a derecha */}
        {!isActive && (
          <span
            className="absolute inset-0 -z-10 origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out rounded-lg"
            style={{ backgroundColor: accentColorPastel }}
          />
        )}
        <span className="relative z-10">{children}</span>
      </Link>
    );
  };

  return (
    <nav className="hidden md:flex md:items-center md:gap-x-8">
      {/* Grupo de los 3 primeros links */}
      <div className="flex gap-x-1">
        <DesktopNavLink
          href="/"
          accentColor={colorPairs[0].accent}
          accentColorPastel={colorPairs[0].pastel}
        >
          Inicio
        </DesktopNavLink>
        <DesktopNavLink
          href="/floradibuja"
          accentColor={colorPairs[1].accent}
          accentColorPastel={colorPairs[1].pastel}
        >
          Conoceme
        </DesktopNavLink>
        <DesktopNavLink
          href="/social"
          accentColor={colorPairs[2].accent}
          accentColorPastel={colorPairs[2].pastel}
        >
          Redes sociales
        </DesktopNavLink>
      </div>
      {/* Último link separado con mayor espacio */}
      <DesktopNavLink
        href="/solicitudPresupuesto"
        accentColor={colorPairs[3].accent}
        accentColorPastel={colorPairs[3].pastel}
        isSpecial
      >
        Trabajemos juntos
      </DesktopNavLink>
    </nav>
  );
};
